import { IPageTabNavLink } from "../interfaces-and-types";

import transaction from "../assets/icons/trans.svg";
import listPad from "../assets/icons/list-pad.svg";
import fraud from "../assets/icons/fraud.svg";
import linkColored from "../assets/icons/link-colored.svg";
import recurring from "../assets/icons/recurring.svg";
import disputes from "../assets/icons/disputes.svg";
import feedback from "../assets/icons/qmark.svg";

interface IMainTabNavLink extends IPageTabNavLink {
  icon?: string;
  isShowMore: boolean;
}

export const mainNavLinks: IMainTabNavLink[] = [
  {
    name: "Home",
    route: "/",
    isShowMore: false,
  },
  {
    name: "Payments",
    route: "/payments",
    isShowMore: false,
  },
  {
    name: "Balances",
    route: "/balances",
    isShowMore: false,
  },
  {
    name: "Reports",
    route: "/reports",
    isShowMore: false,
  },
  {
    name: "Customers",
    route: "/customers",
    isShowMore: false,
  },
  {
    name: "Products",
    route: "/products",
    isShowMore: false,
  },
  {
    name: "Transactions",
    route: "/payments/transactions",
    icon: transaction,
    isShowMore: true,
  },
  {
    name: "Invoices",
    route: "/payments/invoices",
    icon: listPad,
    isShowMore: true,
  },
  {
    name: "Frauds & Risks",
    route: "/payments/frauds",
    icon: fraud,
    isShowMore: true,
  },
  {
    name: "Payment Links",
    route: "/payments/payment-links",
    icon: linkColored,
    isShowMore: true,
  },
  {
    name: "Subscriptions",
    route: "/payments/subscriptions",
    icon: recurring,
    isShowMore: true,
  },
  {
    name: "Disputes",
    route: "/disputes",
    icon: disputes,
    isShowMore: true,
  },
  {
    name: "Feedback",
    route: "/feedback",
    icon: feedback,
    isShowMore: true,
  },
];
